document.addEventListener('DOMContentLoaded', function() {
  // Initialize accordion functionality
  function initAccordion() {
    const accordionItems = document.querySelectorAll('.minimal-accordion-item');
    
    accordionItems.forEach(item => {
      const header = item.querySelector('.minimal-accordion-header');
         
      header.addEventListener('click', () => {
        const wasActive = item.classList.contains('active');
        
        // Close all items first
        accordionItems.forEach(otherItem => {
          otherItem.classList.remove('active');
        });
        
        // Open clicked item if it wasn't already active
        if (!wasActive) {
          item.classList.add('active');
        }
      });
    });
    
    // Open first item by default if none are open
    if (accordionItems.length > 0 && !document.querySelector('.minimal-accordion-item.active')) {
      accordionItems[0].classList.add('active');
    }
  }
  
  // Initialize form handling
  function initForm() {
    const contactForm = document.querySelector('.minimal-contact-form');
    const submitButton = contactForm?.querySelector('.submit-button');
    const loadingSpinner = contactForm?.querySelector('.loading-spinner');
    
    if (contactForm) {
      contactForm.addEventListener('submit', function() {
        if (submitButton && loadingSpinner) {
          submitButton.disabled = true;
          submitButton.innerHTML = 'Sending...';
          loadingSpinner.style.display = 'inline-block';
        }
      });
    }
  }
  
  // Initialize both components
  initAccordion();
  initForm();
  
  // Reinitialize when Shopify theme editor updates content
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initAccordion();
      initForm();
    });
  }
});